import BaseCollectionService from "./base.collection.service";

class FaqService extends BaseCollectionService {
  constructor() {
    super("faq");
  }
}

export default new FaqService();
